export const profileTypes = {
  ADD_FAV: "ADD_FAV",
};
